import React from 'react';
import ThumbsUpIconFilled from 'reusable-components/icons/duotone/ThumbsUpIcon';
import ThumbsUpIcon from 'reusable-components/icons/outline/ThumbsUpIcon';

const CSS = require('./UpvoteButton.module.scss');

type UpvoteButtonProps = {
  nrOfUpvotes: number;
  upvotedByCurrentUser: boolean;
  handleUpvoteClick: () => void;
  isLoading: boolean;
};

const UpvoteButton = ({
  handleUpvoteClick,
  nrOfUpvotes,
  upvotedByCurrentUser,
  isLoading,
}: UpvoteButtonProps) => {
  return (
    <button
      disabled={isLoading}
      onClick={handleUpvoteClick}
      className={CSS.ThumbsUpContent}
      title="Helpful?"
    >
      {upvotedByCurrentUser ? (
        <ThumbsUpIconFilled size={16} variant={'pink'} />
      ) : (
        <ThumbsUpIcon size={16} variant={'black'} />
      )}
      {nrOfUpvotes > 0 && (
        <span className={CSS.NumberOfUpvotes}>{nrOfUpvotes}</span>
      )}
    </button>
  );
};

export default UpvoteButton;
